// Simple memory cache for fast tab switching
const memoryCache: Record<string, { data: any; timestamp: number }> = {};
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getCache = (key: string) => {
  const cached = memoryCache[key];
  if (!cached) return null;
  
  if (Date.now() - cached.timestamp > CACHE_DURATION) {
    delete memoryCache[key];
    return null;
  }
  
  return cached.data;
};

export const setCache = (key: string, data: any) => {
  memoryCache[key] = {
    data,
    timestamp: Date.now()
  };
};

export const clearCache = (key?: string) => {
  if (key) {
    delete memoryCache[key];
  } else {
    for (const k in memoryCache) delete memoryCache[k];
  }
};
